import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import Page from 'components/common/Page';
import { H2 } from '@montel/montelpro-shared-components-v2';

const SubscriptionOutlet: FunctionComponent = () => (
	<Page>
		<H2 as={'h1'}>Subscriptions</H2>
		<Outlet />
	</Page>
);

export default SubscriptionOutlet;
